import styled, { css } from "styled-components";

export const ToShopSectionDesktop = styled.div<{ isClub: boolean }>`
	position: relative;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: ${(props) => (props.isClub ? "0 1em 0 0" : "0 2.7em")};

	img {
		width: ${(props) => (props.isClub ? "19.8em" : "17.3em")};
		z-index: 2;
	}

	p {
		position: relative;
		bottom: ${(props) => (props.isClub ? "-0.8em" : "0")};
		font-family: "Inter";
		font-weight: 700;
		font-size: 2em;
		line-height: 1.3em;
		color: white;
		margin: ${(props) => (props.isClub ? "0 0 0 -3em" : "0 0 0 -6em")};
		filter: drop-shadow(0 0.2199em 0.2199em rgba(0, 0, 0, 0.45));
		width: ${(props) => (props.isClub ? "75%" : "auto")};

		span {
			font-weight: 400;
		}
	}

	button {
		width: 11.7619em;
		height: 2.7619em;
		font-size: 2.1em;
	}

	:before {
		content: "";
		position: absolute;
		top: 0.3em;
		left: 50%;
		transform: translateX(-50%);
		border: 0.1099em solid rgba(0, 0, 0, 0.2);
		width: 96%;
	}

	&.mega-menu-variant {
		padding: 0 1em;

		img {
			width: 15.3em;
		}

		p {
			font-size: 1.7em;
			line-height: 1.3em;
			width: 80%;
			margin: 0 0 0 -3em;
			bottom: 0;
		}

		button {
			font-size: 1.8em;
		}

		:before {
			top: 0.6em;
		}
	}
`;

export const PurchaseCounter = styled.div<{
	isMaxed: boolean;
	isPageVariant?: boolean;
}>`
	border-radius: 1.6493em;
	background: rgba(0, 0, 0, 0.5);
	padding: 0.412em 0.687em;
	width: fit-content;
	margin-top: 0.5em;

	color: ${(props) => (props.isMaxed ? "#EB5757" : "#fbbd05")};
	text-shadow: 0 0.0728em 0 rgba(0, 0, 0, 0.25);
	font-family: "Inter";
	font-size: 1.6em;
	font-style: normal;
	font-weight: 700;
	line-height: 1.125em;

	${(props) =>
		props.isPageVariant &&
		css`
			@media (min-width: 720px) {
				margin-top: 0;
				position: absolute;
				top: 1em;
				left: 8.5em;
			}
		`}
`;

export const ToShopSectionMobile = styled.div`
	position: relative;
	margin-top: 5.5em;

	img {
		width: 16.3em;
		z-index: 2;
		transform: rotateY(180deg);
		margin-left: -7.5em;
	}

	p {
		font-family: "Inter";
		font-weight: 700;
		font-size: 2em;
		line-height: 1.3em;
		color: white;
		margin: 0;
		text-shadow: 0 0.1908em 0.1908em rgba(0, 0, 0, 0.45);

		span {
			font-weight: 400;
			line-height: 1.1em;
		}
	}

	button {
		width: 11.55em;
		height: 2.9em;
		font-size: 2em;
		border-radius: 16px;
		z-index: 3;
	}

	div.shop-section-divider {
		display: flex;
		align-items: center;

		:after {
			content: "";
			position: absolute;
			bottom: -0.1em;
			left: 0;
			border: 1px solid rgba(0, 0, 0, 0.2);
			width: 31.1em;
		}
	}
`;
